import React, { useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { KickOffReturnPlaySelection } from "./KickOffReturnPlaySelection";
import { KickOffReturnReturnLog } from "./KickOffReturnReturnLog";

export const KickOffReturnLogger = () => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  return (
    <Paper elevation={3} sx={{ p: 1, width: 1137, margin: '0 auto' }}>
      <Box>
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffReturnPlaySelection />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "run-log"}
          onChange={handleAccordionChange("run-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="run-log-content"
            id="run-log-header"
          >
            <Typography>Return Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffReturnReturnLog />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};

export default KickOffReturnLogger;